import React from 'react';
import { locales } from '../../../translations/locales';
import IconsCategories from '../sga/IconsCategories';

const AlertDetails = (props) => {
    const { mission, locale } = props;

    return (
        <div className='col-4'>
            <div>
                <IconsCategories locale={locale} icon={mission.qualification.category} style={'20px'} noText={true} />
                {locales[locale].sga[mission.qualification.category]} / {mission.qualification.qualification}
            </div>
            <div className='text-muted'>
                {mission.id}
            </div>
            <div>
                {locales[locale].sig[mission.qualification.place.category]} / {locales[locale].sig[mission.qualification.place.type]}
            </div>
            <div>
                {mission.qualification.informations}
            </div>
            <hr className={`m-1 bg-secondary`} />
            <div>
                {mission.location.numero} {mission.location.address} {mission.location.city}
            </div>
            <div className='text-muted'>
                <div className='row'>
                    <div className='col-3'>
                        <label htmlFor='stage'>{locales[locale].sga.stage}</label>
                        {mission.location.stage}
                    </div>
                    <div className='col-3'>
                        <label htmlFor='gate'>{locales[locale].sga.gate}</label>
                        {mission.location.gate}
                    </div>
                    <div className='col-3'>
                        <label htmlFor='building'>{locales[locale].sga.building}</label>
                        {mission.location.building}
                    </div>
                    <div className='col-3'>
                        <label htmlFor='code'>{locales[locale].sga.code}</label>
                        {mission.location.code}
                    </div>
                </div>
            </div>
            <hr className={`m-1 bg-secondary`} />
            <div>
                {
                    mission.danger === 1 ? (
                        <button className={`btn btn-danger btn-sm pl-4 pr-4 w-100`} disabled>
                            {locales[locale].sga.veryUrgent}
                        </button>
                    ) : mission.danger === 2 ? (
                        <button className={`btn btn-warning btn-sm pl-4 pr-4 w-100`} disabled>
                            {locales[locale].sga.urgent}
                        </button>
                    ) : mission.danger === 3 ? (
                        <button className={`btn btn-light btn-sm pl-4 pr-4 w-100`} disabled>
                            {locales[locale].sga.normal}
                        </button>
                    ) : (
                        <button className={`btn btn-secondary btn-sm pl-4 pr-4 w-100`} disabled>
                            {locales[locale].sga.low}
                        </button>
                    )
                }
            </div>
        </div>
    );
};

export default AlertDetails;
